import React from "react";
import { motion } from "framer-motion";

const CourseCard = ({
  title,
  description,
  imageUrl,
  price,
  duration,
  level,
  instructor,
  category,
  placementTest,
  onViewCourse,
}) => {
  return (
    <motion.div
      className="bg-white rounded-xl shadow-md overflow-hidden h-full flex flex-col transition-all duration-300 hover:shadow-xl border border-gray-100"
      whileHover={{
        y: -5,
        transition: { duration: 0.2 },
      }}
    >
      <div className="relative h-52 overflow-hidden group">
        <img
          src={imageUrl || "https://via.placeholder.com/400x250"}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {/* Placement test gate badge */}
        {placementTest && (
          <div className="absolute top-3 left-3 flex items-center gap-1 bg-indigo-600 text-white text-xs font-bold px-2.5 py-1.5 rounded-full shadow-sm">
            🎯 Test Required
          </div>
        )}

        {category && (
          <div className={`absolute ${placementTest ? "top-3 right-3" : "top-3 right-3"} bg-primary text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm`}>
            {category}
          </div>
        )}

        {level && (
          <div className="absolute bottom-3 left-3 bg-white/90 text-gray-800 text-xs font-medium px-3 py-1.5 rounded-full shadow-sm backdrop-blur-sm">
            {level}
          </div>
        )}
      </div>

      <div className="p-6 flex-grow flex flex-col">
        <h3 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2">
          {title}
        </h3>
        <p className="text-gray-600 text-sm mb-5 flex-grow line-clamp-3">
          {description}
        </p>

        {instructor && (
          <div className="flex items-center mb-4">
            <div className="w-9 h-9 bg-primary/10 text-primary rounded-full flex items-center justify-center mr-3 shadow-sm">
              <span className="text-sm font-bold">{instructor.charAt(0)}</span>
            </div>
            <div>
              <span className="text-sm text-gray-500 block">Instructor</span>
              <span className="text-sm font-medium text-gray-800">
                {instructor}
              </span>
            </div>
          </div>
        )}

        <div className="flex justify-between items-center mt-auto pt-4 border-t border-gray-100">
          {price && (
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Price</span>
              <span className="text-primary font-bold text-lg">
                ${parseFloat(price).toFixed(2)}
              </span>
            </div>
          )}

          {duration && (
            <div className="flex flex-col items-end">
              <span className="text-xs text-gray-500">Duration</span>
              <div className="flex items-center text-gray-700 text-sm font-medium">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {duration}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="bg-gray-50 px-6 py-4">
        <button
          onClick={onViewCourse}
          className={`w-full py-2.5 rounded-lg font-medium transition duration-300 shadow-sm hover:shadow flex items-center justify-center text-white ${
            placementTest
              ? "bg-indigo-600 hover:bg-indigo-700"
              : "bg-primary hover:bg-primary-dark"
          }`}
        >
          <span>{placementTest ? "View & Apply" : "View Course"}</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>
    </motion.div>
  );
};

export default CourseCard;
